import { Routes, Route } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Services from "@/pages/Services";
import NotFound from "@/pages/NotFound";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/content/landing";

export const Shell = () => (
  <>
    <Header />
    <main id="main" className="pb-24 md:pb-0">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/masaj-hizmetleri" element={<Services />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/iletisim" element={<Contact />} />
        {landingPages.map((p) => <Route key={p.path} path={p.path} element={<LandingPage page={p} />} />)}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <Footer />
    <StickyBar />
  </>
);
